import React, { useState } from "react";
import { SlIcon } from "@shoelace-style/shoelace/dist/react";
import copySvg from "../../assets/images/copy.svg";
import { Toast } from "../../shared/Toast";

function AccordionSales(props) {
  const [open, setOpen] = useState(false);
  const handleClickhdl = async(phnnum) => {
    if (phnnum) {
      await navigator.clipboard.writeText(phnnum)
      Toast('success', "Number Copied")
    }
  };
  return (
    <>
      
        {props.data[0].name ? (
          <div>
            <div className="cName">
              <p className="my-0">
                {props.data[0].name}
              </p>
            </div>
            <div className="cContact d-flex justify-between w-40 items-center">
              <div className="d-flex gap-4 items-center">
              <div className="d-flex gap-2 items-center"> 
                <SlIcon
                  library="lucide"
                  name="phone"
                  className="text-[10px] text-green-500"
                ></SlIcon>
                <a className="mobNum" href={`tel:${props.data[0].mobile || props.data[0].mobile2}`}>{props.data[0].mobile ||props.data[0].mobile2}</a>
                </div>
                <img src={copySvg} alt="copy" className="hover:cursor-pointer" onClick={()=>handleClickhdl(props.data[0].mobile ||props.data[0].mobile2)}></img>
              </div>
              <div>
              {!open ? (
                <SlIcon
                  library="lucide"
                  name="chevron-down"
                  className="text-black hover:cursor-pointer text-base"
                  onClick={() => setOpen(true)}
                ></SlIcon>
              ) : (
                <SlIcon
                  library="lucide"
                  name="chevron-up"
                  className="text-black hover:cursor-pointer text-base"
                  onClick={() => setOpen(false)}
                ></SlIcon>
              )}
            </div>
            </div>
           
          </div>
        ) : (
          "-"
        )}
      {open &&
        props.data?.slice(1)?.map((poc) => {
          return (
            <div className="contactModal">
            <div className="mt-2">
              <p className="my-0 text-xs font-semibold capitalize">
                {poc.name}
              </p>
            </div>
            <div className="d-flex justify-between items-center">
              <div className="d-flex gap-4 items-center">
                <div className="d-flex gap-2 items-center"> 
                <SlIcon
                  library="lucide"
                  name="phone"
                  className="text-[10px] text-green-500"
                ></SlIcon>
                <a className="mobNum" href={`tel:${poc.mobile ||poc.mobile2 }`}>{poc.mobile || poc.mobile2}</a>
                </div>
                <img src={copySvg} alt="copy" className="hover:cursor-pointer" onClick={()=>handleClickhdl(poc.mobile || poc.mobile2)}></img>
              </div>
            </div>
            </div>
          );
        })}
    </>
  );
}

export default AccordionSales;
